import { api } from '@/lib/api';

export const auditLogsService = {
  async getAll() {
    const { data } = await api.get('/audit-logs');
    return { data };
  },

  async getByEntity(entityType, entityId) {
    const { data } = await api.get(
      `/audit-logs/entity/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`,
    );
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/audit-logs', body);
    return { data };
  },
};
